//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    page: {
      type: String,
      required: true
    },
    showQuizButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    steps () {
      return this.$t(`quizGift.howItWorks.steps.${this.page}`)
    },
    buttonSize () {
      return this.isTablet() ? 'sm' : 'md'
    },
    buttonTheme () {
      return 'dark'
    }
  },
  methods: {
    onClick () {
      if (this.page === 'improvement_program') {
        this.addDDAction('Quiz clicked', { path: this.$route.path })
        location.href = '/quiz-gifting'
      } else if (this.page === 'one_off') {
        location.hash = ''
        location.hash = '#test-plans'
      }
    }
  }
}
